import React from "react";
import { Box } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { LocalizedText } from "../i18n/LocalizedText.js";
const useClasses = makeStyles()((theme) => {
  return {
    wrappedComponentLabel: {
      ...theme.typography.subtitle2,
      color: theme.palette.text.secondary,
      marginBottom: theme.spacing(1),
      display: "flex"
    }
  };
});
const withLabel = (WrappedComponent) => (props) => {
  const { classes } = useClasses();
  const { label } = props;
  return /* @__PURE__ */ React.createElement(Box, null, /* @__PURE__ */ React.createElement(Box, { component: "span", className: classes.wrappedComponentLabel }, /* @__PURE__ */ React.createElement(LocalizedText, { label })), /* @__PURE__ */ React.createElement(WrappedComponent, { ...props }));
};
export {
  withLabel
};
//# sourceMappingURL=LabelHoc.js.map
